type TelemetrySemanticColors = {
  accent: string;
  attention: string;
  cyan: string;
  danger: string;
  done: string;
  success: string;
};

const knownTelemetryColor = (name: string, colors: TelemetrySemanticColors): string | undefined => {
  const known: Record<string, string> = {
    action_loss: colors.success,
    lr: colors.done,
    epoch: colors.accent,
    "timing/step": colors.attention,
    "timing/model": colors.cyan,
    "timing/data": colors.danger
  };
  return known[name];
};
export const telemetrySeriesColor = (
  name: string,
  index: number,
  isLight: boolean,
  colors: TelemetrySemanticColors
): string => {
  const known = knownTelemetryColor(name, colors);
  if (known) return known;
  const hue = (205 + index * 137.508) % 360;
  return `hsl(${hue.toFixed(1)} ${isLight ? "68% 42%" : "76% 64%"})`;
};

export const comparisonRunColor = (runId: string, isLight: boolean): string => {
  let hash = 2166136261;
  for (const character of runId) {
    hash ^= character.codePointAt(0) ?? 0;
    hash = Math.imul(hash, 16777619);
  }
  const hue = (hash >>> 0) % 360;
  return `hsl(${hue.toFixed(1)} ${isLight ? "68% 42%" : "76% 64%"})`;
};

export const GANTT_ROW_HEIGHT = 24;
export const GANTT_AXIS_HEIGHT = 34;
export const ganttContentHeight = (rowCount: number): number =>
  Math.max(GANTT_AXIS_HEIGHT, rowCount * GANTT_ROW_HEIGHT + GANTT_AXIS_HEIGHT);

export const TENSORBOARD_SMOOTHING_MAX = 0.999;

/**
 * TensorBoard-style first-order IIR/EMA smoothing with correction for the
 * zero-valued accumulator used at the beginning of a series.
 */
export const tensorboardSmooth = (values: number[], requestedWeight: number): number[] => {
  const weight = Math.max(0, Math.min(TENSORBOARD_SMOOTHING_MAX, requestedWeight));
  let accumulator = 0;
  let finitePointCount = 0;

  return values.map((value) => {
    if (!Number.isFinite(value)) return value;
    accumulator = accumulator * weight + (1 - weight) * value;
    finitePointCount += 1;
    const debiasWeight = 1 - Math.pow(weight, finitePointCount);
    return debiasWeight > Number.EPSILON ? accumulator / debiasWeight : value;
  });
};
